import {Box, Card, CardHeader, List, ListItem, Typography} from "@mui/material";
import {translateKey} from "utils/fieldsFormatters";
import type { KeyboardEvent } from "react";
import { use, useEffect, useState } from "react";
import {DESCRIPTOR_ICONS_BY_TYPE, SimilarObject, SimilarObjectsDict} from "consts/khw-consts";
import {LanguageContext} from "context/LanguageContext";
import {useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";

interface DescriptorSimilarObjectsProps {
    records: SimilarObjectsDict
}

const DescriptorSimilarObjects = ({records}: DescriptorSimilarObjectsProps) => {
    const {language} = use(LanguageContext);
    const navigate = useNavigate()
    const [cookies] = useCookies(['source']);
    const [source, setSource] = useState<string>()
    const {DBN, MESH} = records

    useEffect(() => {
        if (cookies.source) {
            setSource(cookies.source)
        } else {
            setSource('DBN')
        }
    }, [cookies])

    const navigateToDescriptorDetails = (nlpId: string) => {
        navigate(`/descriptor-details/${nlpId}`)
    }
    const onKeyDown = (event: KeyboardEvent<HTMLSpanElement>, nlpId: string) => {
        if (event.key === 'Enter' || event.key === 'Space') {
            event.preventDefault()
            navigateToDescriptorDetails(nlpId)
        }
    }

    const renderCardsForSource = (source: string, data: SimilarObject[]) => <Card
            key={source}
            className={'similar-objects-card'}><CardHeader
            className={'similar-card-header'}
            title={translateKey(source, language)}/>
            <List>
                {data.map(item => <ListItem key={item.id} className={'similar-object-item'}
                                           onKeyDown={(event) => onKeyDown(event, item.id)}>
                    <Typography className={'similar-name'} onClick={() => navigateToDescriptorDetails(item.id)}
                                tabIndex={0}>{item.preferredName}</Typography>


                    <Box className={'row new-type-chip yellow-chip'}
                         boxShadow={2}>
                        <img src={DESCRIPTOR_ICONS_BY_TYPE[item.type]} className={'icon-in-chip'}
                             alt={'ogólna grafika deskryptora'}/>
                        <Typography textAlign={'center'}>{translateKey(item.type, language)}</Typography>
                    </Box>

                </ListItem>)}
            </List></Card>

    const renderCardsForAllSources = () => {
        return <>
            {DBN && renderCardsForSource('DBN', DBN)}
            {MESH && renderCardsForSource('MESH', MESH)}

        </>
    }

    const hasData = (source === 'DBN' && records.DBN)
        || (source === 'MESH' && records.MESH)
        || (source === 'all' && (records.DBN || records.MESH))

    if (!hasData) return <Typography
        style={{marginLeft: 15, marginTop: 10}}>{translateKey('noResultsFound', language)}</Typography>

    return <Box className={'similar-objects-box'}>
        <Typography fontWeight={"bold"}>{translateKey('didYouMean', language)}?</Typography>
        {source === 'all' && renderCardsForAllSources()}
        {source === 'DBN'  && DBN && renderCardsForSource('DBN', DBN)}
        {source === 'MESH'  && MESH && renderCardsForSource('MESH', MESH)}
    </Box>
}
export default DescriptorSimilarObjects